module.exports = __webpack_public_path__ + "img/politics.67fd6625.png";